import { useT } from '../../i18n'
import styles from '../note.module.css'

/**
 * Explains what field exposure is and what a grant actually does.
 *
 * The concept needs explaining more than most screens: a grant here changes
 * what another organisation's staff can read — immediately, with no release
 * step — and the two field tiers this screen cannot touch (the always-visible
 * defaults and the never-exposed platform internals) are invisible precisely
 * because they are not configurable. Without the note, an operator cannot
 * tell a careful design from a missing feature.
 *
 * Expanded by default, same reasoning as the gateway note: the person who
 * needs it most is the one arriving for the first time, before their first
 * grant of somebody's personal data. It remains a <details> so anyone tired
 * of it can fold it away.
 */
export function FieldExposureNote() {
  const t = useT()
  return (
    <details className={styles.note} open>
      <summary className={styles.summary}>{t('fieldExposure.note.title')}</summary>
      <div className={styles.body}>
        <p>{t('fieldExposure.note.what')}</p>
        <p>{t('fieldExposure.note.tiers')}</p>
        <p className={styles.key}>{t('fieldExposure.note.impact')}</p>
        <p>{t('fieldExposure.note.how')}</p>
        <p className={styles.caution}>{t('fieldExposure.note.caution')}</p>
      </div>
    </details>
  )
}
